module.exports = __webpack_public_path__ + "static/media/Whitney-Bold.62b7ed79.otf";